import {store} from '..';
import { call, put } from 'redux-saga/effects';
import { url } from '../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';



const getTrailersAPI = () => {

    return APICallingService.sendRequestForGet(url.getTrailersWithLatestLog, (res) => {
    }, true);

}

function* getTrailers() {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getTrailersAPI);
        if (response && response != null && response?.callBackStatus.toLowerCase() == 'success') {

            yield put({
                type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT.GET_RURAL_TRAILER_MANAGEMENT_API_SUCCESS, payload: { value: response.data }
            })

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get trailers data');
                yield put({
                    type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT.GET_RURAL_TRAILER_MANAGEMENT_API_SUCCESS, payload: { value: response.data }
                })
            }
        }


    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT.GET_RURAL_TRAILER_MANAGEMENT_API_SUCCESS, payload: { value: 'Failed' }
        })
    }
}

const getTrailersLogAPI = (action) => {

    let urlLog = url.getTrailerLogs + "/" + action.payload.value.id;
    return APICallingService.sendRequestForGet(urlLog, (res) => {
    }, true);

}

function* getTrailersLog(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getTrailersLogAPI, action);

        if (response && response != null) {

            yield put({
                type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT.GET_RURAL_TRAILER_LOGS_API_SUCCESS, payload: { value: response.data }
            })

        }
        else {
            if (response && response != null && response.Status != 405) {

                alert('Failed to get trailer logs');
                yield put({
                    type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT.GET_RURAL_TRAILER_LOGS_API_SUCCESS, payload: { value: response.data }
                });
            }
        }


    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT.GET_RURAL_TRAILER_LOGS_API_SUCCESS, payload: { value: 'Failed' }
        })
    }
}


export { getTrailers, getTrailersLog };
